import React, { useState } from "react";

import { useIntl } from "react-intl";

import * as Table from "ds/Table";
import { capitalize } from "Libs/utils";
import { useCurrentServiceWorkers } from "Reducers/environment/hooks/useCurrentServiceWorkers";
import EmptyCard from "src/organization/pages/project/environment/services/components/EmptyCard";

import * as S from "./Workers.styles";

import { Worker } from "./";

const Workers = () => {
  const intl = useIntl();

  const workers = useCurrentServiceWorkers().map(worker => ({
    ...worker,
    displayName: worker.name.replace(`${worker?.app}--`, "")
  }));

  const [sortList, setSortList] = useState<{
    by: "name" | "spec";
    order: "asc" | "desc";
  }>({ by: "name", order: "asc" });

  const sortWorkers = (a, b) => {
    const { by, order } = sortList;
    const valA = typeof a[by] === "string" ? a[by].toLowerCase() : a[by];
    const valB = typeof b[by] === "string" ? b[by].toLowerCase() : b[by];
    if (order === "asc") {
      if (valA < valB) return -1;
      if (valA > valB) return 1;
      return 0;
    } else {
      if (valA > valB) return -1;
      if (valA < valB) return 1;
      return 0;
    }
  };

  const workersList = workers.sort(sortWorkers);
  const sortable = workersList.length > 1;

  const handleSortBy = by => {
    if (!sortable) return;
    setSortList({
      by,
      order:
        sortList.by === by ? (sortList.order === "asc" ? "desc" : "asc") : "asc"
    });
  };

  return (
    <S.Wrapper>
      <S.TitleHead tag="h3">
        {intl.formatMessage(
          {
            id: "services.workers.title"
          },
          {
            count: workersList.length,
            b: txt => (
              <S.BodyText size="medium" $color="granite">
                {txt}
              </S.BodyText>
            )
          }
        )}
      </S.TitleHead>
      {!workersList.length ? (
        <EmptyCard>
          {intl.formatMessage({ id: "services.workers.none" })}
        </EmptyCard>
      ) : (
        <S.TableTable>
          <S.TableThead>
            {["name", "version", "size", "disk"].map(field => (
              <Table.Th
                key={`header-${field}`}
                onSortChanged={() => {
                  handleSortBy(field);
                }}
                isSortActive={sortList.by === field}
                sortDirection={sortList.order}
              >
                {capitalize(intl.formatMessage({ id: field }))}{" "}
              </Table.Th>
            ))}
            <Table.Th>{capitalize(intl.formatMessage({ id: "ssh" }))}</Table.Th>
          </S.TableThead>
          <S.Hr />
          <S.TableThead>
            {workersList.map(worker => (
              <Worker key={worker.name} worker={worker} />
            ))}
          </S.TableThead>
        </S.TableTable>
      )}
    </S.Wrapper>
  );
};

export default Workers;
